import { create } from 'zustand';

export type ColorMode = 'light' | 'dark';
export const THEME_KEY = 'leadsmania_theme';
export const accentTokens = {
    blue: { accent: '#0044ff', ink: '#0044ff', contrast: '#ffffff', fill: '#0044ff', soft: '#e7efff' },
};
export function readMode(): ColorMode {
    try {
        return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
}
export const useAppearance = create<{
    mode: ColorMode;
    accent: 'blue';
    setMode: (mode: ColorMode) => void;
}>((set) => ({
    mode: readMode(),
    accent: 'blue',
    setMode: (mode) => {
        if (mode !== 'light' && mode !== 'dark') return;
        try {
            localStorage.setItem(THEME_KEY, mode);
        } catch {
            /* Works for this tab without storage. */
        }
        set({ mode });
    },
}));
